import { useRouter } from '@application/utils';
import type { ArticleWhereInput } from '@gql/graphql';
import { QueryMode } from '@gql/graphql';
import type { ArticleListPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useArticlesWhereBuilder = () => {
  const { languageCode } = useRouter();

  const articlesWhereBuilder = useCallback(
    (form: ArticleListPageFormValues): ArticleWhereInput => {
      const whereInputs: ArticleWhereInput[] = [];

      whereInputs.push({
        published: { equals: true },
      });

      whereInputs.push({
        translations: {
          some: {
            active: { equals: true },
            languageCode: {
              equals: languageCode,
            },
          },
        },
      });

      if (form.tagId) {
        whereInputs.push({
          tags: { has: form.tagId },
        });
      }

      if (form.title) {
        whereInputs.push({
          translations: {
            some: {
              title: {
                contains: form.title,
                mode: QueryMode.insensitive,
              },
            },
          },
        });
      }

      return { ...(whereInputs.length ? { AND: whereInputs } : {}) } as ArticleWhereInput;
    },
    [languageCode],
  );

  return { articlesWhereBuilder };
};
